import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Router from './Router';

import { initialize } from './redux/actions/auth';
import { StoreState } from './types/state';
import { Loader, Dimmer } from 'semantic-ui-react';

function App() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state: StoreState) => state.auth.isLoading);

  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  return (
    <>
      {isLoading ? (
        <Dimmer page>
          <Loader />
        </Dimmer>
      ) : (
        <Router />
      )}
    </>
  );
}

export default App;
